<template>
  <el-badge
    :value="pendingMsgList.length"
    is-dot
    :hidden="pendingMsgList.length === 0"
  >
    <el-popover
      placement="bottom"
      width="580"
      trigger="click"
      :offset="30"
      @show="show"
      @hide="hide"
      v-model="visible"
    >
      <div
        class="after-msg-wrap"
        v-loading="!showMessage"
        :style="{ 'min-height': minheight }"
        v-if="pendingMsgList.length > 0"
      >
        <i
          class="el-icon-close msg-close"
          style=""
          @click="visible = false"
        ></i>
        <div v-if="showMessage" style="padding-bottom: 30px;">
          <div class="msg-item" v-for="item in pendingMsgList" :key="item.id">
            <div class="flex-row-between-center">
              <span class="msg-title after" v-if="item.type == 2"
                >售后消息</span
              >
              <span class="msg-title refuse" v-if="item.type == 3"
                >拒收消息</span
              >
              <span>{{ item.time }}</span>
            </div>
            <div class="flex-row-between-center">
              <div class="">
                <span class="bold">服务编码：{{ item.number }}</span>
                <span class="c-65">（{{ item.strTag }}，请及时跟进）</span>
                <!-- <span class="c-65">（售后客服客户寄回中，请及时跟进）</span> -->
                <!-- <span class="bold">{{ item.info }}</span> -->
              </div>
              <a
                class="handle-btn"
                @click="handleMsg(item)"
                v-if="item.type == 2"
                >去处理
                <i class="el-icon-arrow-right" style="font-size: 12px"></i
              ></a>
            </div>
          </div>
        </div>
        <div
          class="go-all-btn"
          @click="checkAll"
          :style="{
            top:
              82 * pendingMsgList.length > 440
                ? '520px'
                : 82 * pendingMsgList.length + 80 + 'px'
          }"
        >
          查看全部
        </div>
      </div>
      <div class="no-msg-data" v-else>
        暂无数据
      </div>
      <span slot="reference" style="font-size: 12px">待处理通知</span>
      <asOrderDialogVue :item="item" ref="asDialogRef" />
    </el-popover>
  </el-badge>
</template>

<script>
import asOrderDialogVue from "../pendingOrder/asOrderDialog.vue";
import { queryPendingMsgTop, queryAsInfo } from "@/models/aftersaleModel";
export default {
  components: { asOrderDialogVue },
  data() {
    return {
      pendingMsgList: [],
      showMessage: false,
      minheight: "300px",
      visible: false,
      item: {}
    };
  },
  async mounted() {
    this.initMsg();
  },
  methods: {
    show() {
      this.showMessage = false;
      this.initMsg();
      setTimeout(() => {
        this.showMessage = true;
        this.minheight = "100px";
      }, 100);
    },
    hide() {
      this.showMessage = false;
      setTimeout(() => {
        this.minheight = "300px";
      }, 500);
    },
    // 查看全部售后消息
    checkAll() {
      this.visible = false;
      this.$store.dispatch("app/isQueryPendingOrder", "as-order");
    },
    async handleMsg(data) {
      const shop_id = Number(localStorage.getItem("shop_id"));
      try {
        const res = await queryAsInfo({ as_number: data.number, shop_id });
        this.item = { ...data, asType: res.as_type };
        this.$nextTick(() => {
          this.$refs.asDialogRef.showDialog();
        });
      } catch (error) {}
    },
    async initMsg() {
      const params = {
        type: "2,3"
      };
      try {
        const res = await queryPendingMsgTop(params);
        // console.log("待处理消息Top10:", res);
        this.pendingMsgList = res || [];
        // 有待处理消息，一直展示，可手动关闭
        if (res && res.length > 0) {
          this.visible = true;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    }
  }
};
</script>
<style scoped lang="scss">
.after-msg-wrap {
  font-size: 12px;
  padding: 4px;
  line-height: 22px;
  max-height: 500px;
  overflow-y: scroll;
  .msg-close {
    font-size: 20px;
    cursor: pointer;
    width: 100%;
    text-align: right;
    margin-top: -8px;
  }
  .msg-item {
    border: 1px solid #e9e9e9;
    margin-bottom: 12px;
    padding: 12px 16px;
  }
  .msg-title.refuse {
    color: #ff4d4f;
  }
  .bold {
    font-weight: bold;
  }
  .c-65 {
    color: rgba(0, 0, 0, 0.65);
  }
  .handle-btn {
    color: #ff4d4f;
    cursor: pointer;
  }
  .go-all-btn {
    // width: 100%;
    border: 1px solid #dcdfe6;
    color: #606266;
    cursor: pointer;
    transition: 0.1s;
    font-weight: 500;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
    text-align: center;
    position: fixed;
    width: 530px;
    // top: 520px;
    z-index: 999;
    background: #fff;
  }
}
.no-msg-data {
  min-height: 60px;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/afterMsgPop.vue